import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MyApplicationsData } from './my-applications.component.model';

@Injectable({ providedIn: 'root' })
export class MyApplicationsService {
  private dataSource = new BehaviorSubject<MyApplicationsData>({
    summaryDetails: { activeSummaryFilter: '' },
    myApplicationsDetails: { applications: [] },
    reRunSummaryApi: false
  });

  data$ = this.dataSource.asObservable();

  setData(data: MyApplicationsData) {
    this.dataSource.next(data);
  }

  getCurrentData(): MyApplicationsData {
    return this.dataSource.value;
  }
  isInProgressOverlay = false;
  private refreshTrigger = new Subject<void>();
  refresh$ = this.refreshTrigger.asObservable();
  selectedApplicationId: string | null = null;

  triggerRefresh() {
    this.refreshTrigger.next();
  }
}
